import { PORTFOLIO_DATA } from '../shared/data.js';
import { renderNav, initNavigation } from '../shared/navigation.js';
import { renderFooter, initFooter } from '../shared/footer.js';
import { renderProjectCard, renderCompactCard } from '../shared/utils.js';
import '../style.css';

// Detail pages are siblings of this listing (both live in /projects/), so
// links need no prefix.
function render() {
  const main = document.getElementById('allProjects');
  if (!main) return;

  const byYearDesc = (a, b) => (b.year ?? 0) - (a.year ?? 0);
  const projects = PORTFOLIO_DATA.projects;
  const featured = projects.filter(p => p.featured).sort(byYearDesc);
  const learning = projects.filter(p => !p.featured).sort(byYearDesc);

  main.innerHTML = `
    <section class="all-section all-section--first">
      <a href="../index.html" class="pd-back-link">← Back home</a>
      <div class="section-head">
        <div class="section-num">★</div>
        <div class="section-title-wrap">
          <div class="section-kicker">ALL WORK</div>
          <h2 class="section-title">FEATURED&nbsp;<em>BUILDS.</em></h2>
          <div class="section-desc">The headline projects: championship robots, a capstone, and tools I keep coming back to.</div>
        </div>
      </div>
      <div class="project-grid">
        ${featured.map(p => renderProjectCard(p, '')).join('')}
      </div>
    </section>

    <section class="all-section">
      <div class="section-head">
        <div class="section-num">↓</div>
        <div class="section-title-wrap">
          <div class="section-kicker">EVERYTHING ELSE</div>
          <h2 class="section-title">LEARNING&nbsp;&amp;&nbsp;<em>COURSEWORK.</em></h2>
          <div class="section-desc">Smaller builds, university coursework, and early experiments, where a lot of the learning happened.</div>
        </div>
      </div>
      <div class="compact-grid">
        ${learning.map(p => renderCompactCard(p, '')).join('')}
      </div>
    </section>
  `;
}

document.addEventListener('DOMContentLoaded', () => {
  renderNav();
  initNavigation();
  render();
  renderFooter();
  initFooter();
});
